import React, { useState } from 'react'
import { Bar, BarChart, CartesianGrid, Label, Legend, Tooltip, XAxis, YAxis, ResponsiveContainer } from 'recharts'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { capitalize, startCase } from 'lodash'

import KpiBarchartTooltip from '../../kpiBarchartTooltip/KpiBarchartTooltip'
import CustomLegend from '../customLegend/CustomLegend'
import { legendStyling } from '../../../../utils/renderUtils'
import { colors } from '../../../../utils/kpiUtils'
import { kpiColorPalette } from '../../../../js/constants'

const FilterableBarChart = props => {
  // contains data types to be filtered from chart
  const [excludedDataFields, setExcludedDataFields] = useState([])

  /**
   * Removes data type from chart
   * @param dataKey Recharts legend payload
   */
  const handleLegendClick = ({ dataKey }) => {
    const isDataTypeDisabled = excludedDataFields.includes(dataKey)
    if (isDataTypeDisabled) {
      setExcludedDataFields(excludedDataFields.filter(value => value !== dataKey))
    } else {
      setExcludedDataFields(excludedDataFields.concat(dataKey))
    }
  }

  if (!props.labels || isEmpty(props.labels)) {
    return null
  }

  return (
    <ResponsiveContainer width="100%" aspect={4.0 / 3.0}>
      <BarChart data={props.data} margin={props.chartMargins}>
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis dataKey={props.dataKey} interval={0} angle={props.xAxisAngle || 0} height={80} textAnchor="end">
          <Label value={props.xAxisLabel} position="insideBottom" offset={-3} />
        </XAxis>

        <YAxis width={70}>
          <Label
            value={props.yAxisLabel}
            position="insideLeft"
            angle={-90}
            style={{ textAnchor: 'middle' }}
            offset={5}
          />
        </YAxis>
        {!isEmpty(props.data) && (
          <Tooltip content={<KpiBarchartTooltip showTotal={true} labelSuffix={props.tooltipLabelSuffix} />} />
        )}
        {props.labels &&
          props.labels
            .filter(product => !excludedDataFields.includes(product))
            .map((product, idx) => (
              <Bar
                stackId="0"
                key={`${idx}_${product}`}
                name={`${capitalize(startCase(product))}`}
                dataKey={`${product}`}
                fill={props.colors[product] || kpiColorPalette[idx] || '#000000'}
                maxBarSize={props.maxBarSize}
              />
            ))}

        <Legend
          verticalAlign="top"
          wrapperStyle={legendStyling}
          content={<CustomLegend onLegendClick={handleLegendClick} />}
          payload={
            props.labels
              ? props.labels.map((item, idx) => ({
                  dataKey: item,
                  //grey out legend colour if data type is disabled
                  color: excludedDataFields.includes(item)
                    ? colors.grey
                    : props.colors[item] || kpiColorPalette[idx] || '#000000',
                  value: item
                }))
              : undefined
          }
        />
      </BarChart>
    </ResponsiveContainer>
  )
}

FilterableBarChart.propTypes = {
  labels: PropTypes.array.isRequired,
  colors: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  chartMargins: PropTypes.object.isRequired,
  dataKey: PropTypes.string.isRequired,
  xAxisLabel: PropTypes.string.isRequired,
  yAxisLabel: PropTypes.string.isRequired,
  xAxisAngle: PropTypes.number,
  maxBarSize: PropTypes.number,
  tooltipLabelSuffix: PropTypes.string
}

export default FilterableBarChart
